<template>
  <section class="banner">
    <!--工具条-->
    <!--新增界面-->
    <el-col :span="24" class="add_banner pad_left" v-show = "isAdd">
      <section>
        <el-col :span="24" style>
          <p style="width:102px;text-align:center">{{$route.query.type==1?"商家资料查看":"商家资料审核"}}</p>
        </el-col>
      </section>
      <p style="margin-top:30px;margin-left:30px;">
        <span class="red_info"></span>
        <strong style="margin-left:5px;margin-top:-1px;">{{$route.query.type==1?"申请商家入驻资料查看":"申请商家入驻资料填写"}}</strong>
      </p>
      <el-form
        style="margin-left:100px;margin-top:30px;"
        :model="form"
        label-width="130px"
        ref="editForm"
      >
        <el-form-item label="商家名称：" :required="bloon" :show-message="bloon1" prop>
          <el-input v-model="form.name" :disabled = "disabled"  auto-complete="off" style="width:560px"></el-input>
        </el-form-item>
        <el-form-item label="代理品牌：" :required="bloon" :show-message="bloon1" prop>
          <!-- <span class="choice" @click="choice()">选择</span> -->
          <div v-show="showBdName">
            <span style="color:#F56C6C">已选择：</span>
            <span v-for="(item,index) in xuanze" :key="index">{{item.Name}};</span>
          </div>
        </el-form-item>
        <el-form-item label="公司所在地：" :required="bloon" :show-message="bloon1" prop>
          <el-select :disabled = "disabled" v-model="form.ProvinceId" placeholder style="width:140px" @change="selectcity">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in provinceoptions"
              :key="index"
            ></el-option>
            <!-- <el-option label="天津" value="tinajin"></el-option> -->
          </el-select>
          <span style="margin:0 11px" class="dur_title">省</span>
          <el-select :disabled = "disabled" v-model="form.CityId" placeholder style="width:140px;" @change="selectzore">
            <el-option
              :label="item.Name"
              v-for="(item,index) in cityoptions"
              :value="item.Id"
              :key="index"
            ></el-option>
            <!-- <el-option label="西青" value="green"></el-option> -->
          </el-select>
          <span style="margin:0 11px" class="dur_title">市</span>
          <el-select :disabled = "disabled" v-model="form.ZoneId" placeholder style="width:140px">
            <el-option
              v-for="(item,index) in Zoneoptions"
              :label="item.Name"
              :value="item.Id"
              :key="index"
            ></el-option>
            <!-- <el-option label="天津" value="tinajin"></el-option> -->
          </el-select>
          <span style="margin:0 11px" class="dur_title">区/县</span>
          <el-input
          :disabled = "disabled"
            v-model="form.address"
            placeholder="请填写详细地址"
            auto-complete="off"
            style="width:560px"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司电话：" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.OpeningBank" auto-complete="off" style="width:360px"></el-input>
        </el-form-item>
        <el-form-item label="负责人姓名：" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.Contacts" auto-complete="off" style="width:360px"></el-input>
        </el-form-item>
        <el-form-item  label="负责人手机号：" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.Phone" auto-complete="off" style="width:360px" type="email"></el-input>
        </el-form-item>
        <!-- <el-form-item label="合作类型：" :required="bloon" :show-message="bloon1">
          <el-select
            v-model="form.operatypeid"
            placeholder
            style="background:#fff;width:200px"
            @click="showtime()"
          >
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in coperation"
              :key="index"
            ></el-option>
           
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="合作周期：" v-show="showtime" prop>
          <el-col :span="4" style="width: 200px;">
            <el-date-picker type="date" placeholder v-model="form.date1" style="width: 180px;"></el-date-picker>
          </el-col> -->
          <!-- <el-col class="line" style="width:40px" :span="1">
            <img src="../../assets/img/aicon10_03.jpg" alt>
          </el-col>-->
          <!-- <el-col class="line dur_title" style="width:35px" :span="1">至</el-col>
          <el-col :span="4" style="width: 200px;">
            <el-date-picker placeholder v-model="form.date2" style="width: 180px;"></el-date-picker>
          </el-col> -->
          <!-- <el-col class="line" style="width:40px" :span="1">
            <img src="../../assets/img/aicon10_03.jpg" alt>
          </el-col>-->
        <!-- </el-form-item> -->

        <!-- <el-form-item label="回款类型：" :required="bloon" :show-message="bloon1" prop>
          <el-select v-model="form.huikuanid" placeholder style="background:#fff;width:400px">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in huikuanoptions"
              :key="index"
            ></el-option> -->
            <!-- <el-option label="小程序" value="mini"></el-option> -->
          <!-- </el-select>
        </el-form-item> -->
        <!-- <el-form-item
          label="开户银行支行所在地："
          :required="bloon"
          :show-message="bloon1"
          style="margin-left:-22px;"
          label-width="150px;"
          prop>
          <el-select 
          :disabled = "disabled"
            v-model="form.ProvinceylId"
            placeholder
            style="width:140px"
            @change="selectcity1">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in provinceoptions1"
              :key="index"
            ></el-option> -->
            <!-- <el-option label="天津" value="tinajin"></el-option> -->
          <!-- </el-select>
          <span style="margin:0 11px" class="dur_title">省</span>
          <el-select :disabled = "disabled" v-model="form.CityylId" placeholder style="width:140px;" @change="selectzore1">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in cityoptions1"
              :key="index"
            ></el-option> -->
            <!-- <el-option label="西青" value="green"></el-option> -->
          <!-- </el-select>
          <span style="margin:0 11px" class="dur_title">市</span>
          <el-select :disabled = "disabled" v-model="form.ZoneylId" placeholder style="width:140px">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in Zoneoptions1"
              :key="index"
            ></el-option> -->
            <!-- <el-option label="天津" value="tinajin"></el-option> -->
          <!-- </el-select>
          <span style="margin:0 11px" class="dur_title">区/县</span>
        </el-form-item> -->
        <!-- <el-form-item label="开户银行名称：" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.BankName" auto-complete="off" style="width:360px"></el-input>
        </el-form-item>
        <el-form-item label="账号名称：" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.accountName" auto-complete="off" style="width:360px" type="tel"></el-input>
        </el-form-item>
        <el-form-item  label="公司银行账号：" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.BankNo" auto-complete="off" style="width:360px" type="tel"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号：" prop>
          <el-input :disabled = "disabled"
            v-model="form.TaxpayerAccount"
            auto-complete="off"
            style="width:360px"
            type="email"/>
        </el-form-item> -->
      </el-form>
      <p style="margin-top:30px;margin-left:30px;">
        <span class="red_info"></span>
        <strong style="margin-left:5px;margin-top:-1px;">{{$route.query.type==1?"商家运营负责人账号查看":"商家运营负责人账号开通申请"}}</strong>
      </p>
      <el-form
        style="margin-left:90px;margin-top:30px;"
        :model="form"
        label-width="130px"
        ref="editForm"
      >
       <el-form-item label="姓名:" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.yunname" auto-complete="off" style="width:360px"></el-input>
        </el-form-item>
        <el-form-item label="性别:" :required="bloon" :show-message="bloon1" prop>
          <el-select :disabled = "disabled" v-model="form.yunGender" placeholder style="background:#fff;width:360px">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in sex"
              :key="index"
            ></el-option>
            <!-- <el-option label="小程序" value="mini"></el-option> -->
          </el-select>
        </el-form-item>
         <el-form-item label="手机号:" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.yunPhoneNumber" auto-complete="off" style="width:360px"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" :required="bloon" :show-message="bloon1" prop>
          <el-input :disabled = "disabled" v-model="form.yunmailbox" auto-complete="off" style="width:360px"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" style="margin-left:170px">
        <!-- <p @click.native="editSubmit">新 增</p> -->
        <p v-show="$route.query.type==1?false:true" @click="Auditpass()" class="search_btn" >审核通过</p>
        <p v-show="$route.query.type==1?false:true" @click="bohui()" class="search_btn" >驳回</p>
        <p @click="closeBan()" class="search_btn">取消</p>
        <!-- <p @click="showBan()">取 消</p> -->
      </div>
    </el-col>
    <!-- 点击审核通过出现页面 -->
    <el-col :span="24" class="add_banner pad_left" v-show = "adopt">
      <section>
        <el-col :span="24" style>
          <p style="width:102px;text-align:center">商家资料审核</p>
        </el-col>
      </section>
     <p style="margin-top:30px;margin-left:30px;">
        <span class="red_info"></span>
        <strong style="margin-left:5px;margin-top:-1px;">合作信息</strong>
      </p>
      <el-form
        style="margin-left:100px;margin-top:30px;"
        :model="form"
        label-width="130px"
        ref="editForm"
      >
        <el-form-item label="合作类型：" :required="bloon" :show-message="bloon1">
          <el-select
            v-model="form.operatypeid"
            placeholder
            style="background:#fff;width:200px"
            @click="showtime()"
          >
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in coperation"
              :key="index"
            ></el-option>
           
          </el-select>
        </el-form-item>
          <el-form-item label="合作周期：" v-show="this.form.operatypeid == 2" :required="bloon" :show-message="bloon1" prop>
          <el-col :span="4" style="width: 200px;">
            <el-date-picker type="date" placeholder v-model="form.date1" style="width: 180px;"></el-date-picker>
          </el-col>
          <el-col class="line" style="width:40px" :span="1">
            <img src="../../assets/img/aicon10_03.jpg" alt>
          </el-col>
          <el-col class="line dur_title" style="width:35px" :span="1">至</el-col>
          <el-col :span="4" style="width: 200px;">
            <el-date-picker placeholder v-model="form.date2" style="width: 180px;"></el-date-picker>
          </el-col>
          <el-col class="line" style="width:40px" :span="1">
            <img src="../../assets/img/aicon10_03.jpg" alt>
          </el-col>
        </el-form-item>
          <el-form-item label="回款类型：" :required="bloon" :show-message="bloon1" prop>
          <el-select v-model="form.huikuanid" placeholder style="background:#fff;width:400px">
            <el-option
              :label="item.Name"
              :value="item.Id"
              v-for="(item,index) in huikuanoptions"
              :key="index"
            ></el-option>
            <!-- <el-option label="小程序" value="mini"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>  
       <div class="dialog-footer" style="margin-left:130px">
        <!-- <p @click.native="editSubmit">新 增</p> -->
        <p @click="goback()" class="search_btn" >返回上一步</p>
        <p @click="Submit()" class="search_btn" >提交</p>
        <!-- <p @click="showBan()">取 消</p> -->
      </div>
    </el-col>
    <!--点击选择弹框-->
    <el-dialog
      class="overflow"
      style="width:1545px;margin-left:205px;margin-top:50px;"
      title="代理品牌"
      :visible.sync="outerVisible">
      <div>
        <el-input placeholder="请输入关键字" v-model="key1" style="width:250px;" type="email"></el-input>
        <span class="span" style="cursor:pointer" @click="find()">查询</span>
        <span @click="sure" style="cursor:pointer" class="span">确认</span>
        <span @click="outerVisible = false" style="cursor:pointer" class="span">取消</span>
      </div>
      <div class="bdname">
        <span style="margin-left:20px;">品牌名称</span>
      </div>
      <div class="check_box">
        <template>
          <!-- <el-checkbox :indeterminate="false"  v-model="checkAll" text-color="#F56C6C" @change="handleCheckAllChange">全选</el-checkbox> -->
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group
            fill="#F56C6C"
            @change="handleCheckedCitiesChange1"
            v-model="checkedCities"
            text-color="#fff"
          >
            <el-checkbox
              class="shezhi"
              style="margin-top:10px;"
              text-color="#F56C6C"
              v-for="(city,index)  in cities"
              :title="city.Name"
              :label="city"
              :key="index"
            >{{city.Name}}</el-checkbox>
          </el-checkbox-group>
        </template>
      </div>
      <div class="allchange">
        <el-checkbox
          style="margin-top:10px;"
          :indeterminate="false"
          v-model="checkAll"
          text-color="#F56C6C"
          @change="handleCheckAllChange"
        >全选</el-checkbox>
        <span @click="clear()" ref="clear" style="cursor:pointer" class="span1">清空</span>
      </div>
      <el-dialog width="30%" title="内层 Dialog" :visible.sync="innerVisible" append-to-body></el-dialog>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button>-->
      </div>
    </el-dialog>
    <!--点击确认-->
    <el-dialog title="确认" :visible.sync="dialogVisible1" width="30%">
      <span
        style="margin-left:140px;display:inline-block;height:100px;line-height:100px"
      >代理品牌选择完成，您是否选择确认？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="button" @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" class="button" @click="sure1()">确 定</el-button>
      </span>
    </el-dialog>
    <!--点击取消-->
    <el-dialog title="取消" :visible.sync="dialogVisible2" width="30%">
      <span
        style="margin-left:40px;display:inline-block;height:100px;line-height:100px"
      >代理品牌选择完成，取消后将不记载您的数据，您是否确定取消么？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="button" @click="dialogVisible2 = false;">取 消</el-button>
        <el-button type="primary" class="button" @click="sure2()">确 定</el-button>
      </span>
    </el-dialog>
    <!--点击清空-->
    <el-dialog title="清空" :visible.sync="dialogVisible3" width="30%">
      <span
        style="margin-left:85px;display:inline-block;height:100px;line-height:100px"
      >清空后将不保留您选择的代理品牌结果，您是否确认？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="button" @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" class="button" @click="clear1()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { getkind, brandlist,addbrand, yongjin, updatebrand, updatestatus,
  pinpaishang, byIdfindinfo1, UpdateBrandBusinessState } from "../../api/api";

export default {
  data() {
    return {
      issubmit:true,
      disabled:true,
      brandAll: [],
      bloon1: false,
      bloon: true,
      showtime: true,
      ischeck: "",
      showBdName: false,
      xuanze: [],
      key1: "",
      // show:localStorage.checkedCities?true:false,
      agentBrandList: [],
      check: [],
      sex:[
          {
              Id:1,
              Name:"男"
          },
           {
              Id:2,
              Name:"女"
          },
      ],
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      // 开关
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      value4: true,
      dialogVisible: false,
      outerVisible: false,
      innerVisible: false,
      filters: {
        name: "",
        status: 0,
        date1: "",
        date2: ""
      },
      coperation: [],
      users: [],
      total: 100,
      page: 1,
      listLoading: false,
      editFormVisible: false, //编辑界面显是否显示
      form: {
        BbId:"",
        ProvinceylId: 0,
        CityylId: 0,
        ZoneylId: 0,
        ZoneId: 0,
        TaxpayerAccount: "",
        address: "",
        name: "",
        Phone: "",
        OpeningBank: "",
        BankName: "",
        shopnum: "",
        accountName: "",
        BankNo: "",
        state:"",
        Contacts: "",
        ProvinceId: 0,
        CityId: 0,
        operatypeid: 1,
        date1: "",
        date2: "",
        OperatorId: "",
        huikuanid: 1,
        Contacts: "",
        yunname:"",
        yunGender:"",
        yunPhoneNumber:"",
        yunmailbox:""
      },
      // 新增页面
      isAdd: true,
      adopt:false,      
      pageIndex: 1,
      pageSize: 10,
      provinceoptions: "",
      provinceoptions1: "",
      cityoptions: [{ Id: 0, Name: "全部" }],
      cityoptions1: [{ Id: 0, Name: "全部" }],
      Zoneoptions: [{ Id: 0, Name: "全部" }],
      Zoneoptions1: [{ Id: 0, Name: "全部" }],
      enterfenyong: "",
      entergongchaung: "",
      yongjinid: "",
      save: true,
      editId: "",
      key: "",
      statusId: "",
      huikuanoptions: "",
      pickerOptions2: {
        disabledDate: time => {
          let beginDateVal = this.filters.date1;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      }
    };
  },
  methods: {
      //提交
      Submit(){
        if(this.form.operatypeid == ""){
          this.$swal({
            type:"warning",
            text:"请选择合作类型"
          })
          return false
        }else if(this.form.operatypeid == 2){
          if(this.form.date1 == ""){
            this.$swal({
              type:"warning",
              text:"请选择合作周期"
            })
            return false
          }else if(this.form.date2 == ""){
            this.$swal({
              type:"warning",
              text:"请选择合作周期"
            })
            return false
          }
        }else if(this.form.huikuanid == ""){
          this.$swal({
            type:"warning",
            text:"请选择回款类型"
          })
          return false
        }
        if(this.issubmit){
          this.issubmit = false
          var obj = {
            id:this.BbId,
            oper:localStorage.Id,
            state:1,
            remark:"",
            cooperationTypeId:this.form.operatypeid,
            coStarTime:this.form.date1,
            coEndTime:this.form.date2,
            settleTypeId:this.form.huikuanid
          }
          UpdateBrandBusinessState(obj).then(data=>{
            this.issubmit = true
            if(data.ResultCode == 1){
              this.form.operatypeid = ""
              this.form.date1 = ""
              this.form.date2 = ""
              this.form.huikuanid = ""
                this.$router.push({
                    path:"/brand"
                })
                this.$swal({
                type:"success",
                text:"提交成功"
              })
            }
          })
        }
      },
      //审核通过
      Auditpass(){
        this.issubmit = true
      this.isAdd = false;
      this.adopt = true;
       this.form.operatypeid = 1
       this.form.date1 = ""
       this.form.date2 = ""
       this.form.huikuanid = 1
      },
      bohui(){
        var obj = {
            id:this.BbId,
            oper:localStorage.Id,
            state:5,
            remark:"",
            cooperationTypeId:1,
            coStarTime:"",
            coEndTime:"",
            settleTypeId:1
        }
      UpdateBrandBusinessState(obj).then(data=>{
          if(data.ResultCode == 1){
            this.$router.push({
              path:"/brand"
            })
            this.$swal({
              type:"success",
              text:"驳回成功"
            })
          }
      })
      },
    // 返回上一步
    goback(){
      this.isAdd = true;
      this.adopt = false;
      this.operatypeid =  1
      this.date1 =  ""
      this.date2 =  ""
      this.huikuanid = 1     
    },
    closeBan() {
      this.$router.push({
          path:"/brand"
      })
    },
    find() {
      var brands = this.brandAll;
      var searchBrands = [];
      brands.forEach(element => {
        var brandName = element.Name;
        if (
          brandName.indexOf(this.key1) >= 0 ||
          this.key1.indexOf(brandName) >= 0
        ) {
          searchBrands.push(element);
        }
      });
      this.cities = searchBrands;
    },
    //全选本地
    find1() {
      var key = {
        key: this.key1,
        pageIndex: 1,
        pageSize: 100000
      };
      pinpaishang(key).then(data => {
        this.cities = data.ResultObj;
        this.brandAll = this.cities;
        var checkedBrands = [];
        if (localStorage.checkedCities) {
          var tempCheckedBrands = JSON.parse(localStorage.checkedCities);
          for (var i = 0; i < tempCheckedBrands.length; i++) {
            this.cities.forEach(element => {
              var tempBrandId = tempCheckedBrands[i].Id;
              var brandId = element.Id;
              if (tempBrandId === brandId) {
                checkedBrands.push(element);
              }
            });
          }
        }
        this.checkedCities = checkedBrands;
      });
    },
    //确认
    sure() {
      this.dialogVisible1 = true;
    },
    sure1() {
      this.dialogVisible1 = false;
      this.outerVisible = false;
      if (this.ischeck.length > 0) {
        this.showBdName = true;
      } else {
        this.showBdName = false;
      }
      localStorage.checkedCities = JSON.stringify(this.ischeck);
      this.xuanze = JSON.parse(localStorage.checkedCities);
    },
    sure2() {
      this.dialogVisible2 = false;
      this.outerVisible = false;
      this.checkedCities = [];
      this.check = [];
    },
    //清空
    clear() {
      if (this.ischeck.length > 0) {
        this.dialogVisible3 = true;
        this.$refs.clear.style.background = "#F56C6C;";
        this.$refs.clear.style.color = "#fff";
      } else {
        this.dialogVisible3 = false;
        this.$refs.clear.style.background = "#e6e6e6";
        this.$refs.clear.style.color = "#000";
      }
    },
    clear1() {
      //  this.showBdName = false
      this.ischeck = [];
      this.dialogVisible3 = false;
      this.checkedCities = [];
      this.check = [];
      this.checkAll = false;
      this.$refs.clear.style.background = "#e6e6e6";
      this.$refs.clear.style.color = "#000";
      //  localStorage.checkedCities = []
    },
    //选择品牌
    handleCheckAllChange(val) {
      if (val) {
        this.$refs.clear.style.background = "#F56C6C";
        this.$refs.clear.style.color = "#fff";
      } else {
        this.$refs.clear.style.background = "#e6e6e6";
        this.$refs.clear.style.color = "#000";
      }
      this.ischeck = this.cities;
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
      //  this.showBdName = true;
    },
    handleCheckedCitiesChange1(value) {
      this.ischeck = value;
      if (this.ischeck.length > 0) {
        this.$refs.clear.style.background = "#F56C6C";
        this.$refs.clear.style.color = "#fff";
      }
      //  if(value.length>0){
      //     this.showBdName = true
      //  }else{
      //     this.showBdName = false
      //  }

      this.check = value;
      //   localStorage.checkedCities =JSON.stringify(value)
      //  this.xuanze = JSON.parse(localStorage.checkedCities)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    //点击选择
    choice() {
      this.outerVisible = true;
      var loginParams = {
        key: this.key,
        pageIndex: 1,
        pageSize: 100000
      };
      pinpaishang(loginParams).then(data => {
        this.cities = data.ResultObj;
        this.brandAll = this.cities;
        var checkedBrands = [];
        if (localStorage.checkedCities) {
          var tempCheckedBrands = JSON.parse(localStorage.checkedCities);
          for (var i = 0; i < tempCheckedBrands.length; i++) {
            this.cities.forEach(element => {
              var tempBrandId = tempCheckedBrands[i].Id;
              var brandId = element.Id;
              if (tempBrandId === brandId) {
                checkedBrands.push(element);
              }
            });
          }
        }
        this.checkedCities = checkedBrands;
        this.ischeck = this.checkedCities;
        if (this.ischeck.length <= 0) {
          this.$refs.clear.style.background = "#e6e6e6";
          this.$refs.clear.style.color = "#000";
        }
      });
    },
    onSubmit() {
      this.pageIndex = 1;
      this.getbrandlist();
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    setting(scope) {
      this.dialogVisible = true;

      this.yongjinid = scope.Id;
      this.entergongchaung = scope.GcdPriceRate;
      this.enterfenyong = scope.PriceRate;
    },
    showAdd() {
      this.isBanner = false;
      this.isAdd = true;
      this.form.ProvinceylId = 0;
      this.form.CityylId = 0;
      this.form.ZoneylId = 0;
      this.form.accountName = "";
      this.form.TaxpayerAccount = "";
      this.form.BankNo = "";
      this.form.name = "";
      this.form.Phone = "";
      this.form.ProvinceId = 0;
      this.form.CityId = 0;
      this.form.ZoneId = 0;
      this.form.OpeningBank = "";
      this.form.address = "";
      this.form.BankName = "";
      this.form.BankNo = "";
      this.form.Contacts = "";
      this.form.operatypeid = 1;
      this.form.date1 = "";
      this.form.date2 = "";
      this.form.OperatorId = this.$cookie.get("OperatorId");
      this.showBdName = false;
      localStorage.checkedCities = [];
    },
    //新增
    showBan() {
      if (this.form.name == "") {
        this.$notify({
          title: "警告",
          message: "请输入商家名称",
          type: "error",
          duration: 1200
        });
      } else if (this.form.ProvinceId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择省",
          type: "error",
          duration: 1200
        });
      } else if (this.form.CityId === 0) {
        this.$notify({
          title: "警告",
          message: "请选择市",
          type: "error",
          duration: 1200
        });
      } else if (this.form.ZoneId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择区",
          type: "error",
          duration: 1200
        });
      } else if (this.form.address == "") {
        this.$notify({
          title: "警告",
          message: "请填写具体位置",
          type: "error",
          duration: 1200
        });
      } else if (this.form.OpeningBank == "") {
        this.$notify({
          title: "警告",
          message: "请填写公司电话",
          type: "error",
          duration: 1200
        });
      } else if (this.form.Contacts == "") {
        this.$notify({
          title: "警告",
          message: "请填写负责人姓名",
          type: "error",
          duration: 1200
        });
      } else if (this.form.Phone == "") {
        this.$notify({
          title: "警告",
          message: "请填写联系电话",
          type: "error",
          duration: 1200
        });
      } else if (this.form.ProvinceylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行省",
          type: "error",
          duration: 1200
        });
      } else if (this.form.CityylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行市",
          type: "error",
          duration: 1200
        });
      } else if (this.form.ZoneylId == 0) {
        this.$notify({
          title: "警告",
          message: "请选择开户银行区",
          type: "error",
          duration: 1200
        });
      } else if (this.form.BankName == "") {
        this.$notify({
          title: "警告",
          message: "请填写开户银行名称",
          type: "error",
          duration: 1200
        });
      } else if (this.form.accountName == "") {
        this.$notify({
          title: "警告",
          message: "请填写账号名称",
          type: "error",
          duration: 1200
        });
      } else if (this.form.BankNo == "") {
        this.$notify({
          title: "警告",
          message: "请填写公司银行账号",
          type: "error",
          duration: 1200
        });
      } else {
        let that = this;
        var loginParams = {
          bankProvinceId: this.form.ProvinceylId,
          bankCityId: this.form.CityylId,
          bankZoneId: this.form.ZoneylId,
          ZoneId: this.form.ZoneId,
          Name: this.form.name,
          address: this.form.address,
          accountName: this.form.accountName,
          Phone: this.form.Phone,
          ProvinceId: this.form.ProvinceId,
          CityId: this.form.CityId,
          telPhone: this.form.OpeningBank,
          BankName: this.form.BankName,
          BankNo: this.form.BankNo,
          Contacts: this.form.Contacts,
          CooperationTypeId: this.form.operatypeid,
          CoStarTime: this.form.date1,
          CoEndTime: this.form.date2,
          SettleTypeId: this.form.huikuanid,
          OperatorId: this.form.OperatorId,
          TaxpayerAccount: this.form.TaxpayerAccount,
          agentBrandList: this.checkedCities ? this.checkedCities : []
        };
        addbrand(loginParams)
          .then(data => {
            data = data.ResultObj;
            this.checkedCities = [];
            this.isBanner = true;
            this.isAdd = false;
            this.getbrandlist();
            this.$notify({
              title: "成功",
              message: "添加成功",
              type: "success"
            });
          })
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getbrandlist();
    },
    //获取合作类型
    getoperaoptions() {
      let that = this;
      var loginParams = {
        tableName: "tbdcooperationtype",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          this.coperation = data;
          this.form.operatypeid = data[0].Id;
          // this.form.positionId = newdata[0].Id;
        })
        .catch(err => {
          this.logining = false;
        });
    },

    //获取品牌商的列表
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    getbrandlist() {
      let that = this;
      // if (this.filters.date1 != "") {
      //   var date1 =
      //     this.filters.date1.getFullYear() +
      //     "-" +
      //     this.p(this.filters.date1.getMonth() + 1) +
      //     "-" +
      //     this.p(this.filters.date1.getDate());
      // } else {
      //   var date1 = "";
      // }

      // if (this.filters.date2 != "") {
      //   var date2 =
      //     this.filters.date2.getFullYear() +
      //     "-" +
      //     this.p(this.filters.date2.getMonth() + 1) +
      //     "-" +
      //     this.p(this.filters.date2.getDate());
      // } else {
      //   var date2 = "";
      // }
      var loginParams = {
        key: this.filters.name,
        status: this.filters.status,
        startTime: this.filters.date1,
        endTime: this.filters.date2,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      brandlist(loginParams)
        .then(data => {
          this.total = data.RowsCount;
          data = data.ResultObj;
          for (var obj of data) {
            if (obj.StatusId == 1) {
              obj.StatusId = true;
            } else {
              obj.StatusId = false;
            }
          }
          this.users = data;
        })
        .catch(err => {
          this.users = [];
        });
    },
    //获取银行所在地省
    getprovince1() {
      let that = this;
      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          let newdata = data;
          newdata.unshift(obj);
          this.provinceoptions1 = newdata;
          // this.form.positionId = newdata[0].Id;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取银行所在地市
    getcity1() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.form.ProvinceylId
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          let newdata = data;
          newdata.unshift(obj);
          this.cityoptions1 = newdata;
          // this.form.positionId = newdata[0].Id;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取银行所在地区
    getarea1() {
      let that = this;
      var loginParams = {
        tableName: "tBDZone",
        keyWord: "",
        parentId: this.form.CityylId
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          let newdata = data;
          newdata.unshift(obj);
          this.Zoneoptions1 = newdata;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取省
    getprovince() {
      let that = this;
      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          let newdata = data;
          newdata.unshift(obj);
          this.provinceoptions = newdata;
          // this.form.positionId = newdata[0].Id;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    selectcity() {
      let cityid = this.form.ProvinceId;
      this.form.CityId = 0;
      this.getcity();
    },
    selectzore() {
      let cityid = this.form.cityid;
      this.form.ZoneId = 0;
      // this.getarea();
    },
    //获取区
    getarea() {
      let that = this;
      var loginParams = {
        tableName: "tBDZone",
        keyWord: "",
        parentId: this.form.CityId
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          let newdata = data;
          newdata.unshift(obj);
          this.Zoneoptions = newdata;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //获取市
    getcity() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.form.ProvinceId
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          let newdata = data;
          newdata.unshift(obj);
          this.cityoptions = newdata;
          // this.form.positionId = newdata[0].Id;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //编辑
    chakan() {
      var Bbid = {
        bbid: this.BbId
      };
      byIdfindinfo1(Bbid).then(data => {
        // localStorage.ZoneId = data.ResultObj.ZoneId;
        // localStorage.CityylId = data.ResultObj.BankCityId;
        // localStorage.ZoneylId = data.ResultObj.BankZoneId;
        this.isBanner = false;
        this.save = false;
        this.isAdd = true;
        this.editId = data.ResultObj.Id;
        this.form.name = data.ResultObj.Name;
        this.form.Phone = data.ResultObj.Phone;
        this.form.ProvinceId = data.ResultObj.ProvinceName; // 省
        this.form.CityId = data.ResultObj.CityName; // 市
        this.form.OpeningBank = data.ResultObj.TelPhone;
        this.form.accountName = data.ResultObj.AccountName;
        this.form.BankName = data.ResultObj.BankName;
        this.form.ZoneId = data.ResultObj.ZoneName;
        this.form.BankNo = data.ResultObj.BankNo;
        this.form.ProvinceylId = data.ResultObj.BankProvinceId;
        this.form.CityylId = data.ResultObj.BankCityName;
        this.form.ZoneylId = data.ResultObj.BankZoneName;
        this.form.address = data.ResultObj.Address;
        this.form.Contacts = data.ResultObj.Contacts;
        this.form.operatypeid = data.ResultObj.CooperationTypeId;
        // this.form.huikuanid = data.ResultObj.SettleTypeId;
        this.form.date1 = data.ResultObj.CoStarTime;
        this.form.date2 = data.ResultObj.CoEndTime;
        this.form.OperatorId = data.ResultObj.OperatorId;
        this.form.TaxpayerAccount = data.ResultObj.TaxpayerAccount;
        this.form.yunname =  data.ResultObj.BusinessAdminName
        this.form.yunGender =  data.ResultObj.BusinessAdminSex == 0 ? "女" : "男",
        this.form.yunPhoneNumber =  data.ResultObj.BusinessAdminPhone
        this.form.yunmailbox =  data.ResultObj.BusinessAdminEmail
        localStorage.checkedCities = JSON.stringify(
          data.ResultObj.agentBrandList
        );
        this.showBdName = true;
        this.xuanze = JSON.parse(localStorage.checkedCities);
        // this.getcity();
        // this.getarea();
        this.statusId = data.ResultObj.StatusId;
      });
    },

    //确定编辑
    editBan() {
      let that = this;
      var loginParams = {
        id: localStorage.otherId,
        bankProvinceId: this.form.ProvinceylId,
        bankCityId: localStorage.CityylId,
        bankZoneId: localStorage.ZoneylId,
        ZoneId: localStorage.ZoneId,
        Name: this.form.name,
        address: this.form.address,
        accountName: this.form.accountName,
        Phone: this.form.Phone,
        ProvinceId: this.form.ProvinceId,
        CityId: this.form.CityId,
        telPhone: this.form.OpeningBank,
        BankName: this.form.BankName,
        BankNo: this.form.BankNo,
        Contacts: this.form.Contacts,
        CooperationTypeId: this.form.operatypeid,
        CoStarTime: this.form.date1,
        CoEndTime: this.form.date2,
        SettleTypeId: this.form.huikuanid,
        OperatorId: this.form.OperatorId,
        TaxpayerAccount: this.form.TaxpayerAccount,
        agentBrandList: JSON.parse(localStorage.checkedCities)
      };
      updatebrand(loginParams)
        .then(data => {
          this.isBanner = true;
          this.isAdd = false;
          this.checkedCities = [];
          this.$notify.success({
            title: "提示",
            message: "修改成功",
            duration: 1200
          });
          data = data.ResultObj;
          this.getbrandlist();
        })
        .catch(err => {
          this.logining = false;
        });
    },
    xiugai(scope) {
      let that = this;
      let status = "";
      if (scope.StatusId == true) {
        status = 1;
      } else if (scope.StatusId == false) {
        status = 2;
      }

      var loginParams = {
        id: scope.Id,
        status: status,
        oper: that.$cookie.get("OperatorId")
      };
      updatestatus(loginParams)
        .then(data => {
          that.getbrandlist();
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //输入分佣
    fenyongnum(e) {
      if (this.enterfenyong > 100) {
        this.$notify({
          title: "警告",
          message: "输入的数字要小于100",
          type: "warning"
        });
      }
    },
    //设置共创端比例
    gongchuangnum() {
      if (this.entergongchaung > 100) {
        this.$notify({
          title: "警告",
          message: "输入的数字要小于100",
          type: "warning"
        });
      }
    },
    //设置佣金
    setyongjin() {
      let that = this;
      var re = /^[0-9]+.?[0-9]*/;
      if (!re.test(this.enterfenyong)) {
        this.$notify({
          title: "警告",
          message: "请输入正确的佣金比例和分拥比例",
          type: "warning"
        });
      } else if (this.entergongchaung > 100) {
        this.$notify({
          title: "警告",
          message: "输入的数字要小于100",
          type: "warning"
        });
      } else if (this.enterfenyong > 100) {
        this.$notify({
          title: "警告",
          message: "输入的数字要小于100",
          type: "warning"
        });
      } else if (!re.test(this.entergongchaung)) {
        this.$notify({
          title: "警告",
          message: "请输入正确的佣金比例和分拥比例",
          type: "warning"
        });
      } else {
        var loginParams = {
          id: this.yongjinid,
          priceRate: this.enterfenyong,
          gcdPriceRate: this.entergongchaung
        };
        yongjin(loginParams)
          .then(data => {
            this.$notify({
              title: "提示",
              message: "设置成功",
              type: "success"
            });
            that.dialogVisible = false;
            that.getbrandlist();
          })
      }
    },
    //获取回款类型
    gethuikuan() {
      var loginParams = {
        tableName: "tBDBBSettleType",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
          data = data.ResultObj;
          // let obj = {
          //   Id: 0,
          //   Name: "全部"
          // };
          // let newdata = data;
          // newdata.unshift(obj);
          this.huikuanoptions = data;

          // this.form.positionId = newdata[0].Id;
        })
        .catch(err => {
          this.logining = false;
        });
    }
  },
  mounted() {
    this.form.OperatorId = this.$cookie.get("OperatorId");
    this.getoperaoptions();
    //获取回款类型
    this.gethuikuan();
    // this.getbrandlist();
    // this.getprovince();
    // this.getprovince1();
    this.BbId = this.$route.query.BbId
    this.chakan()
  },
  props: ["menuAction"],
  watch: {
    menuAction: function(val) {
      this.menuAction = val;
    }
  }
};
</script>
<style scoped>
.red_info {
  display: inline-block;
  width: 2px;
  background: #F56C6C;
  height: 12px;
  margin-top: 5px;
}
.button {
  background: #fff;
  border: 1px solid #F56C6C;
  color: #F56C6C;
}
.button:hover {
  background: #F56C6C;
  border: 1px solid #F56C6C;
  color: #fff;
}
.allchange {
  height: 35px;
  background: #f6f7f9;
  padding-left: 20px;
  margin-top: 30px;
}
.check_box {
  padding-left: 15px;
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.shezhi {
  width: 80px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.bdname {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #dedede;
  margin-top: 20px;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}
.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}
.span1 {
  display: inline-block;
  width: 50px;
  height: 20px;
  line-height: 20px;
  background: #F56C6C;
  color: #fff;
  text-align: center;

  margin-left: 0px;
}

.choice {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}
.fu_hao {
  color: #bebebe;
  margin-left: 5px;
}
.input_item {
  margin-bottom: 15px;
}
.input_item label {
  width: 120px;
  text-align: right;
  display: inline-block;
  color: #bebebe;
  font-size: 12px;
}
.confirm_btn {
  background: #F56C6C;
  color: #fff;
  border-color: #F56C6C;
}
.cancle_btn {
  border-color: #F56C6C;
  color: #F56C6C;
}
.red {
  color: #F56C6C;
}
.banner .toolbar {
  height: auto;
}

/* 时间  */
/* .toolbar .line {
  margin-left: 20px;
  line-height: 36px;
} */
/* 时间图标 */
/* .toolbar .line img{
  margin-top:8px
} */
.toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}
/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  height: 640px;
  position: relative;
  /* overflow: hidden;
   */
}
/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
.banner_table .el-col-22 p {
  width: 86px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.ban_tab p {
  float: left;

  margin-left: 10%;
}

/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  padding-bottom: 30px;
  position: relative;
}
.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.add_banner .el-col-24 p {
  width: 110px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 40px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
</style>


// WEBPACK FOOTER //
// examine.vue?1282ff73